import { render, staticRenderFns } from "./holiday.vue?vue&type=template&id=f99520aa&"
import script from "./holiday.vue?vue&type=script&lang=ts&"
export * from "./holiday.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "holiday.vue"
export default component.exports